import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-180">
      <div className="max-w-3xl mx-auto text-center" data-id="element-181">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-182">
          Si sos docente de Inglés en primaria o secundaria,
          <br data-id="element-183" />
          <span className="text-[#FF6B00]" data-id="element-184">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-185">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-186">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-187">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-188">
              Domingo a la noche buscando material en internet que nunca queda
              bien
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-189">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-190">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-191">
              Clases improvisadas porque no tenés secuencia ni estructura armada
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-192">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-193">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-194">
              Evaluaciones inventadas porque no tenés criterios claros ni
              rúbricas
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-195">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-196">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-197">
              Horas perdidas buscando actividades que tampoco se adaptan al
              currículo argentino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-198">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-199">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-200">
              Llegar al aula con algo que "más o menos sirve" y después
              arrepentirte
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-201">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-202">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-203">
              Planificaciones para directivos que hacés a las corridas la noche
              anterior
            </p>
          </div>
        </div>

        <p className="text-[#FF6B00] text-2xl sm:text-3xl font-black mb-8" data-id="element-204">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Gold divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B00] to-transparent w-full" data-id="element-205" />
      </div>
    </section>;
}